import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ezr3agq73v: FaireBrandEntity = {
  token: "b_ezr3agq73v",
  type: "brand",
  name: "Twentyten",
  avatarUrl:
    "https://cdn.faire.com/fastly/bcb586c8ae1a9d7470a872f6172b46b399bb150166c983e0b5df71ce6867f7d0.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4f61d0680ac168f4e03be0dcbea8741ac3843a0da4ebbf937b42a645edbc8555.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/bcb586c8ae1a9d7470a872f6172b46b399bb150166c983e0b5df71ce6867f7d0.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4f61d0680ac168f4e03be0dcbea8741ac3843a0da4ebbf937b42a645edbc8555.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 75,
  rating: 4.8,
  reviewCount: 58,
  isInsider: true,
  description:
    "Twentyten is women's apparel brand based in Fullerton, California. We design and create modern to everyday easy to wear clothing for women of all ages.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:49.777Z",
    importedBy: "entity-db-cli",
  },
};
